/**
 * オートスライダー初期化
 *
 * トラック要素を必要回数クローンしてウィンドウ幅を埋める。
 * CSS animation で translateX(-50%) → 0 をループさせるため、
 * 複製後の合計セット数は常に偶数（= translate -50% が原本位置と一致）にする。
 */
function initAutoSliders() {
	const sliders = document.querySelectorAll(
		'.wp-block-best-anniversary-blocks-auto-slider'
	);

	sliders.forEach((slider) => {
		const track = slider.querySelector(
			'.wp-block-best-anniversary-blocks-auto-slider__track'
		);
		if (!track) {
			return;
		}

		const originalItems = Array.from(track.children);
		if (!originalItems.length) {
			return;
		}

		const viewportWidth = slider.clientWidth || window.innerWidth;
		// 表示領域の2倍以上トラック幅を確保すれば -50% アニメでも隙間が出ない
		const targetWidth = viewportWidth * 2;

		const appendSet = () => {
			originalItems.forEach((item) => {
				const clone = item.cloneNode(true);
				clone.setAttribute('aria-hidden', 'true');
				track.appendChild(clone);
			});
		};

		let sets = 1;
		const MAX_SETS = 20; // 無限ループ保険

		while (track.scrollWidth < targetWidth && sets < MAX_SETS) {
			appendSet();
			sets++;
		}

		// セット数を必ず偶数にしてシームレスループを保証
		if (sets % 2 !== 0) {
			appendSet();
		}
		
		track.classList.add('animate');
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initAutoSliders);
} else {
	initAutoSliders();
}
